import patch from './patch';

export default () => patch({
  user: null,
  auth: { token: '' },
  ui: { spinner: false },
});
